import { render, staticRenderFns } from "./print-case-label.vue?vue&type=template&id=3b12d5d8&"
import script from "./print-case-label.vue?vue&type=script&lang=ts&"
export * from "./print-case-label.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports